import { z } from "zod";

import {
  AsyncWorkflowTypeValues,
  AsyncWorkflowWarningSeverityValues,
} from "../types/enums.js";

const NonEmptyStringSchema = z.string().min(1);
const IsoTimestampSchema = z.string().datetime({ offset: true });

export const AsyncWorkflowWarningContextValueSchema = z.union([
  z.string(),
  z.number(),
  z.boolean(),
  z.null(),
]);

export const AsyncWorkflowWarningSchema = z
  .object({
    workflowType: z.enum(AsyncWorkflowTypeValues),
    workflowId: NonEmptyStringSchema,
    warningId: NonEmptyStringSchema,
    severity: z.enum(AsyncWorkflowWarningSeverityValues),
    stage: NonEmptyStringSchema,
    code: NonEmptyStringSchema,
    message: NonEmptyStringSchema,
    dedupeKey: NonEmptyStringSchema,
    entityType: NonEmptyStringSchema.optional(),
    entityId: NonEmptyStringSchema.optional(),
    sampleContext: z
      .record(NonEmptyStringSchema, AsyncWorkflowWarningContextValueSchema)
      .optional(),
    occurrenceCount: z.number().int().positive(),
    firstSeenAt: IsoTimestampSchema,
    lastSeenAt: IsoTimestampSchema,
  })
  .strict();

export const AsyncWorkflowWarningPageSchema = z
  .object({
    items: z.array(AsyncWorkflowWarningSchema),
    nextCursor: z.string().optional(),
  })
  .strict();
